/**
 * iframe-factory.ts — create the booking <iframe> element.
 *
 * All modes share the same iframe config:
 *   - scrolling="no"  (the embed manages its own internal scroll)
 *   - allow="payment" (Stripe payment element requires this)
 *   - fixed 720px height (prevents infinite resize loop with dvh)
 *   - loading="eager" (we want it ready as fast as possible)
 */

import { el } from './dom'
import { buildIframeSrc, EmbedConfig } from './config'

declare const __MP_CDN__: string

export function createIframe(config: EmbedConfig): HTMLIFrameElement {
  const src = buildIframeSrc(config, __MP_CDN__)

  const iframe = el('iframe', {
    src,
    class:       'mp-embed-iframe',
    allow:       'payment',
    scrolling:   'no',
    loading:     'eager',
    // Accessibility
    title:       'Book an appointment',
    // Security
    referrerpolicy: 'strict-origin-when-cross-origin',
  }) as HTMLIFrameElement

  // Prevent focus from leaving the iframe when navigating with Tab
  // (full focus trap is handled by a11y.ts at the container level)
  iframe.setAttribute('tabindex', '0')

  return iframe
}
